// @link https://stackoverflow.com/a/56588036
export default function JoinRowspanTableModule(element) {

    const table = element;

    let headerCell = null;

    for (let row of table.rows) {
        const firstCell = row.cells[0];
        
        if (headerCell === null || firstCell.innerText !== headerCell.innerText) {
            headerCell = firstCell;
        } else {
            headerCell.rowSpan++;
            firstCell.remove();
        }
    }
   
    return this;
}
